import React from 'react'
import {BrowserRouter, Route, Routes, useLocation} from 'react-router-dom'
import Login from '../Login/Login'
import Home from '../Home/Home'
import AuthProvider from '../ProviderAuth/AuthProvider'
import NavBar from '../NavBar/NavBar'
import NoFoundPage from '../NoFound/NoFoundPage'
import StoreProvider from '../Store/StoreProvider'
import AdministrarPrestamos from '../Prestamos/AdministrarPrestamos'
import NavBarPublico from '../NavBar/NavBarPublico'
import LinksApp from '../LinksApp/LinksApp'
import { Dropdown, DropdownTrigger, DropdownMenu, DropdownItem, Button, Tabs, Tab } from '@heroui/react'

import PrivateRoute from './PrivateRoute'
import SistemaPagos from '../SistemaPagos/SistemaPagos'
import PerfilPublicoSimplificado from '../PerfilPublico/PerfilPublicoSimplificado'

// Componente interno para manejar las rutas con acceso a useLocation
const RouterContent = () => {
  const location = useLocation()

  // Función para determinar si es una ruta pública (perfil de usuario)
  const esRutaPublica = () => {
    const pathname = location.pathname
    // Ruta pública: /:nombreUsuario (pero no rutas que empiecen con /login, /links, etc.)
    const esPerfilPublico = pathname.match(/^\/[a-zA-Z0-9_-]+$/) && 
                           !pathname.match(/^\/(login|links|configurar-perfil|prestamos|bancas)/)
    return esPerfilPublico
  }

  return (
    <AuthProvider>
      <StoreProvider>
        {/* Solo mostrar NavBars si NO es una ruta pública */}
        {!esRutaPublica() && (
          <>
            <NavBarPublico/>
            <NavBar/>
          </>
        )}
        <Routes>
          {/* Rutas públicas */}
          <Route path='/login' Component={Login}/>
          <Route path='/:nombreUsuario' Component={PerfilPublicoSimplificado}/>
          
          {/* Rutas privadas - requieren autenticación */}
          <Route path='/' element={
            <PrivateRoute>
              <PerfilPublicoSimplificado/>
            </PrivateRoute>
          } />
          
          
          <Route path='/sistema-pagos' element={
            <PrivateRoute>
              <SistemaPagos />
            </PrivateRoute>
          } />
          
          
          {/* Ruta 404 - pública */}
          <Route path='/*' Component={NoFoundPage}/>
        </Routes>
      </StoreProvider>
    </AuthProvider>
  )
}

const AppRouter = () => {
  return (
    <div className='flex flex-col w-full h-full'>
      <BrowserRouter className="">
        <RouterContent />
      </BrowserRouter>
    </div> 
  )
}

export default AppRouter